import { render } from "./BlogSlider.vue?vue&type=template&id=0b7d0562&lang=true"
import script from "./BlogSlider.vue?vue&type=script&lang=js"
export * from "./BlogSlider.vue?vue&type=script&lang=js"

import "./BlogSlider.vue?vue&type=style&index=0&id=0b7d0562&lang=scss"

import exportComponent from "C:\\Users\\MrBin\\Desktop\\Front\\vac2\\VAC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__